import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { UserPlanFragment } from '../../../fragments/UserPlanFragment'

const query = gql`
  query me($first: Int!, $page: Int) {
    me {
      plans(first: $first, page: $page) {
        data {
          ...UserPlanFragment
        }
        paginatorInfo {
          total
          hasMorePages
          currentPage
          lastPage
        }
      }
    }
  }
  ${UserPlanFragment}
`

const transformer = ({ me }: any): any => me

type variables = any

export default queryServiceCreator<variables>(query, transformer)
